<form
  *ngIf="form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  enctype="multipart/form-data"
>
  <div class="row">
    <div class="col-12 col-md-6 col-lg-4">
      <div class="inpt-title">
        {{ "tenant" | transloco }} {{ "name" | transloco }}
      </div>
      <div
        [appValidateState]="form.get('name')"
        class="form-group form-floating mb-3"
      >
        <input
          formControlName="name"
          type="text"
          class="inpt"
          placeholder="Tenant name"
          i18n-placeholder="Tenant name placeholder @@tenantName"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "cvr" | transloco }}</div>
        <input
          formControlName="cvr"
          type="text"
          class="inpt"
          placeholder="CVR number"
          i18n-placeholder="Tenant CVR number placeholder @@cvr"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "address" | transloco }}</div>
        <input
          formControlName="address"
          type="text"
          class="inpt"
          placeholder="Tenant address"
          i18n-placeholder="Tenant address placeholder @@address"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "mainMail" | transloco }}</div>
        <input
          formControlName="mainMail"
          type="text"
          class="inpt"
          placeholder="Main mail"
          i18n-placeholder="Main mail placeholder @@mainMail"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "phone" | transloco }}</div>
        <input
          formControlName="phoneNumber"
          type="text"
          class="inpt"
          placeholder="Phone number"
          i18n-placeholder="Tenant phone number placeholder @@phoneNumber"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "URL" | transloco }}</div>
        <input
          formControlName="preferedUrl"
          type="text"
          class="inpt"
          placeholder="URL"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group form-floating mb-3 mb-lg-5">
        <app-datalist-select
          class="app-datalist-select-double-height"
          [options]="featureOptions"
          [multiple]="true"
          [activeValue]="form.value.featureIds"
          (activeValueChange)="updateValue('featureIds', $event)"
          label="{{ 'features' | transloco }}"
        ></app-datalist-select>
      </div>
      <div class="form-group form-floating">
        <app-datalist-select
          class="app-datalist-select-double-height"
          [options]="mobileFeatureOptions"
          [multiple]="true"
          [activeValue]="form.value.mobileFeatureIds"
          (activeValueChange)="updateValue('mobileFeatureIds', $event)"
          label="{{ 'mobile' | transloco }} {{ 'menu' | transloco }}"
        ></app-datalist-select>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-md-0 mt-5">
      <div class="form-group form-floating">
        <div class="inpt-title">
          {{ "tenant" | transloco }} {{ "remarks" | transloco }}
        </div>
        <textarea
          rows="4"
          style="height: 100%"
          formControlName="remarks"
          type="text"
          class="inpt inpt-lg"
          placeholder="Tenant Remarks"
          i18n-placeholder="Tenant remarks placeholder @@remarks"
        ></textarea>
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-4">
      <div class="select-logo-section row">
        <div class="col-12 col-md-6">
          <div class="inpt-title">
            {{ "desktop" | transloco }} {{ "logo" | transloco }}
          </div>
          <app-media-library-multiple-files-selector
            [allowImagesSelection]="true"
            [mediaLibraryFiles]="[logoMediaLibraryFile!]"
            [uploadOnlyPrivateFilesModeActive]="true"
            (onFileSelected)="onDesktopLogoMediaLibraryFileSelected($event)"
            (onFileRemoved)="onLogoMediaLibraryFileRemoved(true)"
          ></app-media-library-multiple-files-selector>
        </div>

        <div class="col-12 col-md-6 mt-3 mt-md-0">
          <div class="inpt-title">
            {{ "mobile" | transloco }} {{ "logo" | transloco }}
          </div>
          <app-media-library-multiple-files-selector
            [allowImagesSelection]="true"
            [mediaLibraryFiles]="[mobileLogoMediaLibraryFile!]"
            [uploadOnlyPrivateFilesModeActive]="true"
            (onFileSelected)="onMobileLogoMediaLibraryFileSelected($event)"
            (onFileRemoved)="onLogoMediaLibraryFileRemoved(false)"
          ></app-media-library-multiple-files-selector>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "allowUnauth" | transloco }}</div>
        <input
          formControlName="allowUnauthorizedAccess"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "useChatGPT" | transloco }}</div>
        <input
          formControlName="chatGPTForTenant"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "useChatGPTForCoach" | transloco }}</div>
        <input
          formControlName="chatGPTForCoach"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">Public DataRoom</div>
        <input
          formControlName="publicDataRoom"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">Hide MediaLibrary Folder</div>
        <input
          formControlName="hideMediaLibraryFolder"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-3">
        <div class="inpt-title">Hide Users Folder</div>
        <input
          formControlName="hideUsersFolder"
          class="form-check-input"
          type="checkbox"
        />
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-4">
      <div
        class="form-group form-floating mb-3"
        *ngIf="authRepo.isSuperAdmin$ | async"
      >
        <div class="inpt-title">{{ "partnerTenant" | transloco }}</div>
        <input
          formControlName="isPartnerTenant"
          class="form-check-input"
          type="checkbox"
          (change)="changeIsPartner($event)"
        />
      </div>
      <div class="form-group form-floating mb-3" *ngIf="calendarHere$">
        <div class="inpt-title">{{ "showCalendarAsList" | transloco }}</div>
        <input
          formControlName="showCalendarAsList"
          class="form-check-input"
          type="checkbox"
        />
      </div>

      <div class="form-group form-floating mb-3">
        <div class="inpt-title">{{ "useSpeechToText" | transloco }}</div>
        <input
          formControlName="speechToText"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-xl-3">
        <div class="inpt-title">{{ "useLiveAvatar" | transloco }}</div>
        <input
          formControlName="liveAvatar"
          class="form-check-input"
          type="checkbox"
        />
      </div>
      <div class="form-group form-floating mb-xl-3">
        <div class="inpt-title">{{ "disableTenant" | transloco }}</div>
        <input
          formControlName="isDisabled"
          class="form-check-input"
          type="checkbox"
        />
      </div>
    </div>
    <div class="mb-3">
      <app-datalist-select
        [forUsers]="true"
        class="app-datalist-select-double-height"
        [options]="userOptions"
        [multiple]="true"
        label="{{ 'users' | transloco }}:"
        [(activeValue)]="selectedUserIds"
        (activeValueChange)="updateValue('userIds', $event)"
      />
      <div
        *ngIf="
          (form.get('userIds')?.touched &&
            form.get('userIds')?.errors?.['required']) ||
          form.get('userIds')?.errors?.['noUsers']
        "
        class="text-danger mt-1"
      >
        {{ "selectAtLeastOneUser" | transloco }}
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title me-3">
        {{ "primaryColor" | transloco }}
      </div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="primaryColor"></p-colorpicker>
        <input
          type="text"
          formControlName="primaryColor"
          class="form-control ms-2"
          [value]="form?.value.primaryColor"
        />
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title me-3">
        {{ "secondaryColor" | transloco }}
      </div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="secondaryColor"></p-colorpicker>
        <input
          formControlName="secondaryColor"
          type="text"
          class="form-control ms-2"
          [value]="form?.value.secondaryColor"
        />
      </div>
    </div>

    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title me-3">
        {{ "backgroundColor" | transloco }}
      </div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="backgroundColor"></p-colorpicker>

        <input
          type="text"
          formControlName="backgroundColor"
          class="form-control ms-2"
          [value]="form?.value.backgroundColor"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title">{{ "menuBackgroundColor" | transloco }}</div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="menuBackgroundColor"></p-colorpicker>
        <input
          type="text"
          class="form-control ms-1"
          formControlName="menuBackgroundColor"
          [value]="form?.value.menuBackgroundColor"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title">{{ "appThemeColor" | transloco }}</div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="appThemeColor"></p-colorpicker>
        <input
          type="text"
          class="form-control ms-1"
          formControlName="appThemeColor"
          [value]="form?.value.appThemeColor"
        />
      </div>
    </div>
    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title">{{ "emailColor" | transloco }}</div>
      <div class="d-flex align-items-center">
        <p-colorpicker formControlName="emailColor"></p-colorpicker>
        <input
          type="text"
          class="form-control ms-1"
          formControlName="emailColor"
          [value]="form?.value.emailColor"
        />
      </div>
    </div>
    <!-- <div class="col-12 col-md-6 col-lg-4 mb-3"> -->
    <div class="col-12 col-md-6 col-lg-3 mt-3">
      <div class="inpt-title me-3">
        {{ "font" | transloco }}
      </div>
      <!-- <p-dropdown
        placeholder="Default"
        class="w-100"
        [options]="fontOptions"
        formControlName="fontFamily"
      ></p-dropdown> -->

      <app-datalist-select
        placeholder="Default"
        [options]="fontOptions"
        [multiple]="false"
        [activeValue]="form.get('fontFamily')?.value"
        (activeValueChange)="updateValue('fontFamily', $event)"
      ></app-datalist-select>
    </div>
    <div
      *ngIf="isPartner && (authRepo.isSuperAdmin$ | async)"
      class="row p-0 m-0 partnerBox"
    >
      <div class="col-12 col-md-6 col-lg-4">
        <div
          class="form-group form-floating mb-3"
          [class.is-invalid]="
            form.get('maxUsersCanCreate')?.hasError('min') ||
            form.get('maxUsersCanCreate')?.hasError('pattern')
          "
        >
          <div class="inpt-title">{{ "maxUsers" | transloco }}</div>
          <input
            formControlName="maxUsersCanCreate"
            class="inpt"
            type="number"
            min="0"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4">
        <div
          class="form-group form-floating mb-3"
          [class.is-invalid]="
            form.get('maxTenantsCanCreate')?.hasError('min') ||
            form.get('maxTenantsCanCreate')?.hasError('pattern')
          "
        >
          <div class="inpt-title">{{ "maxTenants" | transloco }}</div>
          <input
            formControlName="maxTenantsCanCreate"
            class="inpt"
            type="number"
            min="0"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-6 col-lg-4 mt-3">
    <div class="form-group form-floating pb-3 d-grid">
      <button
        type="submit"
        class="btn btn-orange shadow-sm"
        i18n="Save button @@save"
      >
        {{ "save" | transloco }}
      </button>
    </div>
  </div>
</form>
